<script setup lang="ts">
  import nativeHelper from "@/lib/nativeHelper.ts"
  import { cn } from "@/lib/utils"
  import { Button } from "@/components/ui/button"
  import Icon from "@/components/ui/icons/Icon.vue"

  const DEFAULT_ERROR = "Something went wrong, please reload."

  interface Props {
    textSize?: "default" | "small"
    message?: string | null
    hideReload?: boolean
  }

  withDefaults(defineProps<Props>(), {
    textSize: "default",
    message: DEFAULT_ERROR,
    hideReload: !nativeHelper.isNative(),
  })

  const reload = () => {
    globalThis.location.reload()
  }
</script>

<template>
  <div role="alert">
    <h2 class="body-text-strong flex-inline flex items-center gap-2">
      <Icon name="Warning" size="lg" />
      <span>Failed to load</span>
    </h2>
    <p
      v-if="message"
      :class="cn('mt-1', textSize === 'small' ? 'text-xs sm:text-sm' : 'label')"
    >
      {{ message }}
    </p>

    <Button
      v-if="message === DEFAULT_ERROR && !hideReload"
      class="-ml-1 mt-2"
      icon="Reload"
      icon-position="left"
      size="sm"
      @click.prevent="reload"
    >
      Reload
    </Button>
  </div>
</template>
